import React from "react";
import { StyledButtonStyled } from "./StyledButton.style";
import { ButtonProps } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IStyledButton extends ButtonProps {
  bg?: string;
  tint?: string;
  title: string;
  height?: number;
  disabled?: boolean;
}
const StyledButton: React.FC<IStyledButton> = ({
  bg,
  tint,
  title,
  height,
  disabled,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <StyledButtonStyled
      bg={bg}
      tint={tint}
      height={height}
      disabled={disabled}
      {...props}
    >
      {title || t("general.add")}
    </StyledButtonStyled>
  );
};

export default StyledButton;
